<template>
  <div id="notification-bar">
    <div
      v-for="x of notificationQueue"
      :key="x.toString()"
      class="notification"
      :class="{
        show: x.show,
        green: x.vueClass === 'green',
        red: x.vueClass === 'red',
      }"
    >
      <!-- {{ x.msg }} -->
        {{ x.msg }}
    </div>
  </div>
  
</template>

<script>

const NotificationBarApp = {
  name: 'NotificationBar',
  data() {
    return {
      notificationQueue: [
        // {
        //   msg: String,
        //   vueClass: String,    // red for error, green for all other
        //   show: Boolean,       // defaults to false
        // }
      ],
      transitionTime: .3,
    }

  },
  methods: {

    showNotification( data, sec=4 ) {
      const { notification } = data;
      if ( !notification ) return;

      const { msg, type } = notification;
      
      // push notification to queue
      const notificationObj = {
        msg,
        vueClass: ( type === 'error' ) ? 'red' : 'green',
      };
      this.notificationQueue.push( notificationObj );
      
      // add a short delay to change show value to allow animation
      // notificationObj.show = true;
      setTimeout(() => {
        notificationObj.show = true;
        this.$forceUpdate()
      }, 50);

      // hide bar when done
      // TODO: there is a bug here, the notification at idx 0 slow closes but when it is spliced it triggers the the new idx to transition open... which looks weird because it is already open
      setTimeout(() => {
        this.notificationQueue[0].show = false;
        setTimeout(() => {
          this.notificationQueue.splice(0,1);
        }, this.transitionTime * 1000);
      }, (sec - this.transitionTime) * 1000);

      // this is to stop anything in thenable from running after the notification
      if ( type === 'error' ) throw new Error(msg);
    }
  },
  mounted() {
    window.showNotification = this.showNotification;

    // to make sure we only have to update the transition time in one location
    this.$el.style.setProperty('--nav-transition-time', `all ${this.transitionTime}s`);
  }
};

export default NotificationBarApp;

</script>

<style>
  #notification-bar {
    width: 100%;
    /* height: 0px; */
    /* transition: all .3s; */
    transform: var(--nav-transition-time);
    overflow: hidden;
    position: absolute;
    z-index: 1000;
  }

  .notification {
    height: 0px;
    transition: all .3s;
    border-radius: var(--fla-border-radius);
    box-sizing: border-box;
  }

  .notification.show {
    height: 2rem !important;
  }

  .green { 
    background-color: green; 
    color: white;
  }
  .red { 
    background-color: red; 
  }

</style>